module.exports = __webpack_public_path__ + "img/bitcoin5.598f3fbc.png";